module.exports = __webpack_public_path__ + "img/no-precisa.f95ffb03.png";